import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      d: "M8.874 14.82c4.058 4.079 7.961 4.941 9.405 5.02.936-1.373 1.327-2.47 1.56-3.451-.975-.98-2.458-1.96-3.745-2.51l-1.562 1.569c-.546-.157-1.99-.745-3.746-2.51-1.756-1.765-2.38-3.255-2.497-3.765l1.56-1.568C9.304 6.27 8.29 4.82 7.353 3.84c-1.054.196-2.146.588-3.512 1.49.078 1.451.936 5.373 5.034 9.49ZM12.756 9.24c1.12 0 2 .88 2 2M12.756 7.24c2.2 0 4 1.8 4 4"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      d: "M12.756 5.24c3.32 0 6 2.68 6 6"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "phone"}) } }